import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/TruckDriverReports';

const TruckDriverReportsPage = () => {
  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default TruckDriverReportsPage;
